import { Autocomplete, Banner, Typography } from '@weareopenr/component-library';
import { UseFormReturn, useController, useWatch } from 'react-hook-form';
import { usePriceSchemes } from '../../../hooks/usePriceSchemes/usePriceSchemes';
import { IOptionGroupValues } from '../types';
import styles from '../CreateOptionGroupModal.module.scss';

interface IOptionGroupPriceSchemesProps {
  useFormReturn: UseFormReturn<IOptionGroupValues>;
}

export const OptionGroupPriceSchemes = ({ useFormReturn }: IOptionGroupPriceSchemesProps) => {
  const { data: priceSchemes, isLoading } = usePriceSchemes();
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormReturn;

  const optionGroupName = useWatch({ control, name: 'name' });

  const {
    field: { onChange, value },
  } = useController({
    control,
    name: 'price_scheme_ids',
    rules: {
      required: 'Please select at least one price scheme',
      validate: (val) => (Array.isArray(val) && val.length > 0) || 'Please select at least one price scheme',
    },
  });

  return (
    <>
      <Typography size="xxlarge" className={styles['heading-text']}>
        Define Price Schemes for <span className={styles['bold-text']}>{optionGroupName}</span>
      </Typography>
      <Typography>Select a price scheme to begin setting prices for this option group.</Typography>
      <section className={styles['section']}>
        <div className={styles['price-scheme-container']}>
          <div className={styles['autocomplete']}>
            <Autocomplete
              multiple
              name="price_scheme_ids"
              label="Price Schemes"
              loading={isLoading}
              options={(priceSchemes || []).map((scheme) => ({ value: scheme.id, label: scheme.name }))}
              value={value ?? []}
              onChange={(priceSchemeIds) => {
                clearErrors('price_scheme_ids');
                onChange(priceSchemeIds);
              }}
              limitChips={2}
              error={errors.price_scheme_ids?.message?.toString()}
            />
          </div>
        </div>

        <Banner
          text={
            <>
              <strong>Quick note</strong> - All schemes used at publish require prices. You can add these via the Price
              Schemes page or directly via the option group details page
            </>
          }
        />
      </section>
    </>
  );
};
